import { queryId } from "../components/UrlValidation";
import { EVENT_TYPE } from "../interfaces/AdminEvent";

const PATH_BY_TYPE: Record<number, string> = {
  [EVENT_TYPE.OPENING_WAREHOUSE]: "/opening-warehouse/search-product",
  [EVENT_TYPE.FESTA]: "/festa/search-product",
  [EVENT_TYPE.PAJUSPIEL]: "/pajuspiel/search-product",
};

/** 행사 유형·URL 코드로 포털 상대 경로 (`?c=`) 생성. 불가하면 `null` */
export function activeEventPortalPath(
  type: number,
  urlCode: string,
): string | null {
  const code = urlCode.trim();
  if (!code) return null;
  const base = PATH_BY_TYPE[type];
  if (!base) return null;
  const q = new URLSearchParams({ [queryId]: code });
  return `${base}?${q.toString()}`;
}

export const EVENT_TYPE_LABEL: Record<number, string> = {
  [EVENT_TYPE.OPENING_WAREHOUSE]: "창고개방전",
  [EVENT_TYPE.FESTA]: "페스타",
  [EVENT_TYPE.PAJUSPIEL]: "파주슈필",
};

export function eventTypeLabel(type: number | undefined): string {
  if (type == null) return "—";
  return EVENT_TYPE_LABEL[type] ?? `유형 ${type}`;
}

/** 브라우저에서 접속할 때 사용하는 절대 URL (QR 등) */
export function portalAbsoluteUrl(portalHref: string): string {
  if (typeof window === "undefined") return portalHref;
  return new URL(portalHref, window.location.origin).href;
}
